"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrowserLanguage = exports.getLanguage = void 0;

exports.getLanguage = function (str) {
  if (str.length > 2) return str.substring(0, 2);else return str;
};

exports.getBrowserLanguage = function () {
  var nav = window.navigator;
  var browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'];

  if (Array.isArray(nav.languages)) {
    for (var i = 0; i < nav.languages.length; i++) {
      var l = nav.languages[i];

      if (l) {
        return exports.getLanguage(l);
      }
    }
  }

  for (var _i = 0; _i < browserLanguagePropertyKeys.length; _i++) {
    var language = nav[browserLanguagePropertyKeys[_i]];

    if (language) {
      return exports.getLanguage(language);
    }
  }

  return null;
};